// 상단바 기수·회사 선택 목록.
//
// 목록의 정본은 basicinfo-service API 다(api/scope.ts). 여기 상수는 **API 가 응답하기 전 첫 화면과
// 실패했을 때의 대체값**이다 — 값은 시드와 같다(s_gisu: fi-be 시드 08, s_com: basicinfo-be 시드 09).

export interface GisuOption {
  gisu: number;
  /** 화면 표기 — 기수 번호와 사업연도 */
  label: string;
}

export interface ComOption {
  comSq: number;
  nm: string;
}

export const GISU_OPTIONS: GisuOption[] = [
  { gisu: 1, label: '제1기 (2024)' },
  { gisu: 2, label: '제2기 (2025)' },
  { gisu: 3, label: '제3기 (2026)' },
  { gisu: 4, label: '제4기 (2027)' },
];

export const COM_OPTIONS: ComOption[] = [
  { comSq: 1, nm: '세무법인 정담' },
  { comSq: 2, nm: '한빛테크' },
  { comSq: 3, nm: '대성물류' },
  { comSq: 4, nm: '미래건설' },
  { comSq: 5, nm: '그린푸드' },
  { comSq: 6, nm: '상록수산업' },
];

/** 처음 열 때의 선택 — 진행 중인 기수와 사무소 자신 */
export const DEFAULT_GISU = 3;
export const DEFAULT_COM_SQ = 1;

/** API 응답을 선택기 표기로 옮긴다 — 사업연도는 시작일의 연도다(기수 시작일이 없으면 번호만) */
export function gisuLabel(gisu: number, startDa: string | null): string {
  return startDa ? `제${gisu}기 (${startDa.slice(0, 4)})` : `제${gisu}기`;
}
